import config from '../config';
import axios from 'axios';

export class Images {

     static readFile = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => {
                resolve(reader.result);
            }
            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        })
    }

    static uploadFile = async (buffer, filename) => {

        let formData = new FormData();
        formData.append('file', new Blob([buffer]), filename ? filename : 'image');

        const options = {
            url: `${config.API_ADDR}/images`,
            method: 'POST',
            data: formData,
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        const { data: {link} } = await axios(options);
        return link;

    }
}
